import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { CommandResult } from 'src/app/_models/commandResult';
import { CreatePersonnageCommand } from 'src/app/_models/_commands/createPersonnageCommand';
import { Astre, Astres } from '../../_enums/astre';
import { Legion, Legions } from '../../_enums/legion';
import { Personnage } from '../../_models/personnage';
import { CharacterSheetService } from '../../_services/character-sheet.service';

@Component({
  selector: 'app-character-sheets-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CharacterSheetsCreateComponent implements OnInit {
  personnage!: CreatePersonnageCommand;
  characterSheetForm!: FormGroup;
  submitted: boolean = false;
  isHumain: boolean = false;

  public legions = new Legions;
  public astres = new Astres;

  constructor(private formBuilder: FormBuilder, private characterSheetService: CharacterSheetService, private router:Router) {
   }

  ngOnInit(): void {

    if (this.personnage == undefined)
    {
      this.personnage = new CreatePersonnageCommand;
    }
    this.characterSheetForm = this.formBuilder.group({
      nom: [this.personnage.nom, Validators.required],
      legion: [this.personnage.legion, Validators.required],
      astre1: [this.personnage.astre1, Validators.required],
      astre2: [this.personnage.astre2]
    });

  }

      // convenience getter for easy access to form fields
      get f() { return this.characterSheetForm.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.characterSheetForm.invalid)
    {
    // Get all Form Controls keys and loop them
      Object.keys(this.characterSheetForm.controls).forEach(key => {
      // Get errors of every form control
      var control = this.characterSheetForm.get(key);
      if(control != null)
      {
        console.log(key);
        console.log(control.errors);
      }
    });
      return;
    }

      const command = this.characterSheetForm.value;
      if (!this.isHumain)
        command.astre2 = null;
      this.characterSheetService.createPersonnage(command)
      .pipe(first())
      .subscribe({
        next: (commandResult: CommandResult) =>
        {
          console.log(commandResult);
          this.router.navigateByUrl(`/characterSheets/${(commandResult.result as Personnage).id}`);
        }
      }); 
  }

  onLegionChange() {
    this.isHumain = this.characterSheetForm.value.legion == Legions.LegionHumain;

    if (this.characterSheetForm.value.legion == Legions.LegionEpouvantail) {
      this.characterSheetForm.controls['astre1'].addValidators(this.createEpouvantailValidator());  
    } else {                
        this.characterSheetForm.controls['astre1'].clearValidators();    
        this.characterSheetForm.controls['astre1'].addValidators(Validators.required);                
    }
    this.characterSheetForm.controls['astre1'].updateValueAndValidity();


    if(this.isHumain){
      this.characterSheetForm.controls['astre2'].addValidators(Validators.required);               
    } else {                
        this.characterSheetForm.controls['astre2'].clearValidators();               
    }
    this.characterSheetForm.controls['astre2'].updateValueAndValidity();
  }

  createEpouvantailValidator(): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {

        const value = control.value;

        if (!value) {
            return null;
        }

        const isValid = value != Astres.Saronide && value != Astres.PortePeste && value != Astres.Cannibale;
        return !isValid? {epouvantailAstreError: true}: null;
    }
}
}
